import { Fragment, useEffect, useState } from 'react';
import { Card, Col } from 'reactstrap';
import Loading from '../../../Themes/Components/Loading';
import ConfiguracaoUsuariosService from '../../../Services/Configuracao/ConfiguracaoUsuariosService';
import TableChart from './TableChart';
import EtapasChart from '../Components/EtapasChart';
import LinhasChart from '../Components/LinhasChart';
import DoughnutChart from './DoughnutChart';
import PieChart from './PieChart';
import TotaisChart from './TotaisChart';
import FavoritosChart from './FavoritosChart';
import EventosDetalheChart from './EventosDetalheChart';
import { toast } from 'react-toastify';
import ImportacaoProcessosService from '../../../Services/Importacao/ImportacaoProcessosService';
import ExportacaoProcessosService from '../../../Services/Exportacao/ExportacaoProcessosService';

const Chart = ({ data, plugin, filtro }) => {
  const [loading, setLoading] = useState(true);
  const [graficoData, setGraficoData] = useState(null);

  useEffect(() => {
    const getData = async () => {
      try {
        let responseData = null;
        let configId = null;
        let grafico = data.id;

        if (grafico.includes('personalizado_eventos')) {
          [grafico, configId] = grafico.split('-');
        }

        const isEventosDetalhe = data.id.startsWith('personalizado_eventos_detalhe');

        if (!data.id.includes('_favoritos')) {
          const params = {};
          if (filtro?.data_abertura) params.data_abertura = filtro.data_abertura;
          if (filtro?.data_abertura_inicio) params.data_abertura_inicio = filtro.data_abertura_inicio;
          if (filtro?.data_abertura_fim) params.data_abertura_fim = filtro.data_abertura_fim;
          if (filtro?.data_situacao) params.data_situacao = filtro.data_situacao;
          if (filtro?.data_situacao_inicio) params.data_situacao_inicio = filtro.data_situacao_inicio;
          if (filtro?.data_situacao_fim) params.data_situacao_fim = filtro.data_situacao_fim;
          if (filtro?.situacao_processo) params.situacao_processo = filtro.situacao_processo;
          responseData = await ConfiguracaoUsuariosService.getGrafico(grafico, configId, params);
        } else {
          switch (plugin) {
            case 'importacao':
              responseData = await ImportacaoProcessosService.index(null, 1, 5, 'modified', 'DESC', null, true);
              responseData.tipo = 'favoritos';
              break;
            case 'exportacao':
              responseData = await ExportacaoProcessosService.index(
                null,
                1,
                5,
                'Processos.modified',
                'DESC',
                null,
                true,
              );
              responseData.tipo = 'favoritos';
              break;
          }
        }

        if (isEventosDetalhe && responseData) {
          responseData.tipo = 'eventos_detalhe';
          responseData._configId = configId;
          responseData._grafico = grafico;
        }

        setGraficoData(responseData);
        setLoading(false);
      } catch (e) {
        toast.error('Erro ao carregar o gráfico.');
        setLoading(false);
      }
    };

    getData();
  }, [data, plugin]);

  if (loading) {
    return (
      <Fragment>
        <Col sm={data.tamanho}>
          <Card>
            <Loading />
          </Card>
        </Col>
      </Fragment>
    );
  }

  let chart = null;

  if (!graficoData) {
    return <></>;
  }

  switch (graficoData.tipo) {
    case 'etapa':
      chart = <EtapasChart data={graficoData} index={`/${plugin}/processos`} />;
      break;
    case 'linha':
      chart = <LinhasChart data={graficoData} />;
      break;
    case 'tabela':
      chart = <TableChart data={graficoData} />;
      break;
    case 'doughnut':
      chart = <DoughnutChart data={graficoData} />;
      break;
    case 'pie':
      chart = <PieChart data={graficoData} />;
      break;
    case 'total':
      chart = <TotaisChart data={graficoData} />;
      break;
    case 'favoritos':
      chart = <FavoritosChart data={graficoData} plugin={plugin} />;
      break;
    case 'eventos_detalhe':
      chart = <EventosDetalheChart data={graficoData} configId={graficoData._configId} plugin={plugin} />;
      break;
  }

  return (
    <Fragment>
      <Col md={data.tamanho}>{chart}</Col>
    </Fragment>
  );
};

export default Chart;
